import { Card as PalmettoCard, CardProps as PalmettoCardProps } from '@palmetto/palmetto-components';
import classNames from 'classnames';
import React, { AnchorHTMLAttributes } from 'react';

import { RemoveIndex } from '../../utils/types';

import styles from './Card.module.scss';

type CleanCardProps = Omit<RemoveIndex<PalmettoCardProps>, 'subdued' | 'background'> &
  AnchorHTMLAttributes<HTMLAnchorElement>;

export interface CardProps extends CleanCardProps {
  variant?: 'selected' | 'error' | 'inverted';
  semiTransparentBg?: boolean;
  defaultCorners?: boolean;
}

export const Card: React.FC<CardProps> = (props: CardProps) => {
  const { className, children, variant, semiTransparentBg, defaultCorners, ...restProps } = props;

  return (
    <PalmettoCard
      className={classNames(
        styles.card,
        className,
        'rounded-card-radius-default! border-card-border-100 border-border-default',
        {
          [styles.selected]: variant === 'selected',
          [styles.error]: variant === 'error',
          [styles.inverted]: variant === 'inverted',
          [styles.semiTransparentBg]: semiTransparentBg,
        },
      )}
      {...restProps}
    >
      {children}
    </PalmettoCard>
  );
};
